import React from "react";
import { PropTypes } from "prop-types";
// Modern imports
import Typography from "@limitless/modern/data-display/typography/Typography";
import Grid from "@limitless/modern/layout/Grid";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
//Limitless imports
import CheckboxOutlineIcon from "@limitless/icons/CheckboxOutline";
import CheckedIcon from "@limitless/icons/Checked";
import ModernTaskListAvatar from "../modern-task-avatar/ModernTasksAvatar";
import ModernTenantAvatar from "../modern-tenant-avatar/ModernTenantAvatar";

const ModernTaskFiltersCheckbox = ({ label, labelVariant, tenantName, includeAvatar = true, taskType, ...rest }) => {
    return (
        <FormControlLabel
            control={
                <Checkbox
                    icon={
                        <CheckboxOutlineIcon
                            sx={{ color: theme => theme.palette.primary.light }}
                            viewBox="0 0 20 20"
                            fontSize="small"
                        />
                    }
                    checkedIcon={<CheckedIcon height={20} sx={{ color: theme => theme.palette.primary.light }} />}
                    disableRipple
                    sx={{ paddingLeft: "2px" }}
                    {...rest}
                />
            }
            label={
                <Grid
                    container
                    direction={"row"}
                    alignItems={"center"}
                    sx={{
                        display: "flex",
                        width: "100%",
                        overflow: "hidden",
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                        whiteSpace: "normal"
                    }}
                >
                    {includeAvatar && (
                        <>
                            {tenantName ? (
                                <ModernTenantAvatar tenantName={tenantName} />
                            ) : (
                                <ModernTaskListAvatar type={taskType} size={"small"} />
                            )}
                        </>
                    )}
                    <Typography variant={labelVariant} color="textPrimary" paddingLeft={1} sx={{ lineHeight: "20px" }}>
                        {label}
                    </Typography>
                </Grid>
            }
        />
    );
};

export default ModernTaskFiltersCheckbox;

ModernTaskFiltersCheckbox.propTypes = {
    label: PropTypes.string,
    labelVariant: PropTypes.string,
    tenantName: PropTypes.string,
    taskType: PropTypes.string,
    includeAvatar: PropTypes.bool
};
